import { apiRequest } from './api';

export type TicketStatus = 'waiting_support' | 'waiting_user' | 'closed';
export interface Ticket {
  id: number;
  subject: string;
  status: TicketStatus;
  created_at: string;
  updated_at: string;
  owner?: { id: number; name: string; email: string } | null;
}
export interface TicketMessage {
  id: number;
  author_name: string;
  is_staff: boolean | number;
  body: string;
  created_at: string;
}
export const ticketStatusLabel: Record<TicketStatus, string> = {
  waiting_support: 'Ожидает ответа поддержки', waiting_user: 'Ответ поддержки', closed: 'Закрыт',
};
export const ticketsAPI = {
  list: (scope: string, page = 1) => apiRequest<{ success: boolean; tickets: Ticket[]; page: number; has_more: boolean }>(`/tickets?scope=${scope}&page=${page}`),
  create: (subject: string, body: string) => apiRequest<{ success: boolean; ticket: Ticket }>('/tickets', { method: 'POST', body: JSON.stringify({ subject, body }) }),
  show: (id: number, before?: number) => apiRequest<{ success: boolean; ticket: Ticket; messages: TicketMessage[]; has_more: boolean }>(`/tickets/${id}${before ? `?before=${before}` : ''}`),
  reply: (id: number, body: string) => apiRequest(`/tickets/${id}/messages`, { method: 'POST', body: JSON.stringify({ body }) }),
  status: (id: number, status: 'closed' | 'waiting_support') => apiRequest(`/tickets/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) }),
};
